import { injectInspector, CanvasPoolSingleton, getColorMatrixFilter, Matrix, Canvas, SvgGraphics, drawPath, Filter, getDefaults, clamp, Color, MorphologyFilter, BlurFilter, MorphologyMode, Transform, DEG_TO_RAD, Padding, Bounds, Convolution3x3Filter } from '@tencent/alloy-renderer';

var ColorAdjustmentFilter = /*@__PURE__*/function (Filter) {
  function ColorAdjustmentFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "color-adjustment";
    this._colorMatrixDirty = true;
    this._temperatureScale = [1, 1, 1];
    this._colorMatrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

    var _a, _b, _c, _d, _e;

    var defaults = getDefaults(this);
    this._temperature = (_a = options.temperature) != null ? _a : defaults.temperature;
    this._contrast = (_b = options.contrast) != null ? _b : defaults.contrast;
    this._brightness = (_c = options.brightness) != null ? _c : defaults.brightness;
    this._saturate = (_d = options.saturate) != null ? _d : defaults.saturate;
    this._grayscl = (_e = options.grayscl) != null ? _e : defaults.grayscl;

    if (options.duotone) {
      this._duotone = options.duotone;
    }

    if (options.biLevel || options.biLevel === 0) {
      this._biLevel = options.biLevel;
    }

    if (options.luminance) {
      this._luminance = options.luminance;
    }
  }

  if (Filter) ColorAdjustmentFilter.__proto__ = Filter;
  ColorAdjustmentFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  ColorAdjustmentFilter.prototype.constructor = ColorAdjustmentFilter;
  var prototypeAccessors = {
    temperature: {
      configurable: true
    },
    contrast: {
      configurable: true
    },
    brightness: {
      configurable: true
    },
    saturate: {
      configurable: true
    },
    grayscl: {
      configurable: true
    },
    duotone: {
      configurable: true
    },
    biLevel: {
      configurable: true
    },
    luminance: {
      configurable: true
    },
    colorMatrix: {
      configurable: true
    },
    temperatureScale: {
      configurable: true
    }
  };

  prototypeAccessors.temperature.get = function temperature() {
    return this._temperature;
  };

  prototypeAccessors.temperature.set = function temperature(value) {
    if (this._temperature === value) {
      return;
    }

    this._temperature = value;

    this._updated();
  };

  prototypeAccessors.contrast.get = function contrast() {
    return this._contrast;
  };

  prototypeAccessors.contrast.set = function contrast(value) {
    if (this._contrast === value) {
      return;
    }

    this._contrast = value;

    this._updated();
  };

  prototypeAccessors.brightness.get = function brightness() {
    return this._brightness;
  };

  prototypeAccessors.brightness.set = function brightness(value) {
    if (this._brightness === value) {
      return;
    }

    this._brightness = value;

    this._updated();
  };

  prototypeAccessors.saturate.get = function saturate() {
    return this._saturate;
  };

  prototypeAccessors.saturate.set = function saturate(value) {
    if (this._saturate === value) {
      return;
    }

    this._saturate = value;

    this._updated();
  };

  prototypeAccessors.grayscl.get = function grayscl() {
    return this._grayscl;
  };

  prototypeAccessors.grayscl.set = function grayscl(value) {
    if (this._grayscl === value) {
      return;
    }

    this._grayscl = value;

    this._updated();
  };

  prototypeAccessors.duotone.get = function duotone() {
    return this._duotone;
  };

  prototypeAccessors.duotone.set = function duotone(value) {
    if (this._duotone === value) {
      return;
    }

    this._duotone = value;

    this._updated();
  };

  prototypeAccessors.biLevel.get = function biLevel() {
    return this._biLevel;
  };

  prototypeAccessors.biLevel.set = function biLevel(value) {
    if (this._biLevel === value) {
      return;
    }

    this._biLevel = value;

    this._updated();
  };

  prototypeAccessors.luminance.get = function luminance() {
    return this._luminance;
  };

  prototypeAccessors.luminance.set = function luminance(value) {
    if (this._luminance === value) {
      return;
    }

    this._luminance = value;

    this._updated();
  };

  prototypeAccessors.colorMatrix.get = function colorMatrix() {
    var m = this._colorMatrix;

    if (!this._colorMatrixDirty) {
      return m;
    }

    this._colorMatrixDirty = true;
    var ref = this;
    var saturate = ref.saturate;
    var grayscl = ref.grayscl;
    var biLevel = ref.biLevel;
    var duotone = ref.duotone;
    var luminance = ref.luminance;
    var ref$1 = this;
    var brightness = ref$1.brightness;
    var contrast = ref$1.contrast;

    if (luminance) {
      contrast = luminance.contrast;
      brightness = luminance.brightness * 0.55;
    }

    var ref$2 = this.temperatureScale;
    var tr = ref$2[0];
    var tg = ref$2[1];
    var tb = ref$2[2];
    var bc = brightness * contrast;
    var sr = bc * tr;
    var sg = bc * tg;
    var sb = bc * tb;
    m[0] = (0.213 + 0.787 * saturate) * sr;
    m[1] = (0.715 - 0.715 * saturate) * sg;
    m[2] = (0.072 - 0.072 * saturate) * sb;
    m[5] = (0.213 - 0.213 * saturate) * sr;
    m[6] = (0.715 + 0.285 * saturate) * sg;
    m[7] = (0.072 - 0.072 * saturate) * sb;
    m[10] = (0.213 - 0.213 * saturate) * sr;
    m[11] = (0.715 - 0.715 * saturate) * sg;
    m[12] = (0.072 + 0.928 * saturate) * sb;

    if (contrast === 0) {
      var con = 0.5 * brightness;
      m[4] = con;
      m[9] = con;
      m[14] = con;
    } else {
      var con$1 = (1 - contrast) / 2 / contrast;
      m[4] = con$1 * (m[0] / tr + m[1] / tg + m[2] / tb);
      m[9] = con$1 * (m[5] / tr + m[6] / tg + m[7] / tb);
      m[14] = con$1 * (m[10] / tr + m[11] / tg + m[12] / tb);
    }

    if (grayscl || biLevel || duotone) {
      var L = 0.299;
      var M = 0.587;
      var N = 0.114;
      var originMatrix = [].concat(m);
      m[0] = L * (originMatrix[0] + originMatrix[1] + originMatrix[2]);
      m[1] = M * (originMatrix[0] + originMatrix[1] + originMatrix[2]);
      m[2] = N * (originMatrix[0] + originMatrix[1] + originMatrix[2]);
      m[5] = L * (originMatrix[5] + originMatrix[6] + originMatrix[7]);
      m[6] = M * (originMatrix[5] + originMatrix[6] + originMatrix[7]);
      m[7] = N * (originMatrix[5] + originMatrix[6] + originMatrix[7]);
      m[10] = L * (originMatrix[10] + originMatrix[11] + originMatrix[12]);
      m[11] = M * (originMatrix[10] + originMatrix[11] + originMatrix[12]);
      m[12] = N * (originMatrix[10] + originMatrix[11] + originMatrix[12]);
      m[15] = L * (originMatrix[15] + originMatrix[16] + originMatrix[17]);
      m[16] = M * (originMatrix[15] + originMatrix[16] + originMatrix[17]);
      m[17] = N * (originMatrix[15] + originMatrix[16] + originMatrix[17]);
    }

    return m;
  };

  prototypeAccessors.temperatureScale.get = function temperatureScale() {
    var val = this.temperature - 6500;
    var temperature = val > 0 ? 5e3 - val / 5 : 6500 + Math.abs(val);
    temperature = temperature / 100;
    var red = 255;
    var green = 255;
    var blue = 255;

    if (temperature < 65) {
      red = 255;
      green = temperature - 2;
      green = -115.25485562709179 - 0.44596950469579133 * green + 104.49216199393888 * Math.log(green);
      blue = temperature - 10;
      blue = -204.76935184120902 + 0.8274096064007395 * blue + 115.67994401066147 * Math.log(blue);
    } else if (temperature > 65) {
      red = temperature - 55;
      red = 351.97690566805693 + 0.114206453784165 * red - 33.25366309332127 * Math.log(red);
      green = temperature - 50;
      green = 325.4494125711974 + 0.07943456536662342 * green - 18.0852963507957 * Math.log(green);
      blue = 255;
    }

    this._temperatureScale[0] = clamp(red, 0, 255) / 255;
    this._temperatureScale[1] = clamp(green, 0, 255) / 255;
    this._temperatureScale[2] = clamp(blue, 0, 255) / 255;
    return this._temperatureScale;
  };

  ColorAdjustmentFilter.prototype.apply = function apply(obj, canvas) {
    if (this.hasReColor()) {
      this.drawGlColorAdjustmentFilter(canvas);
      return;
    }

    if (this.forbidWebgl) {
      this.applySvgColorAdjustmentFilter(canvas);
    } else {
      this.applyGlColorAdjustmentFilter(canvas, obj);
    }
  };

  ColorAdjustmentFilter.prototype.applySvgColorAdjustmentFilter = function applySvgColorAdjustmentFilter(canvas) {
    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution);
    var matrix = this.colorMatrix;
    var filterId = getColorMatrixFilter(canvas.width, canvas.height, matrix[0] + " " + matrix[1] + " " + matrix[2] + " " + matrix[3] + " " + matrix[4] + "\n      " + matrix[5] + " " + matrix[6] + " " + matrix[7] + " " + matrix[8] + " " + matrix[9] + "\n      " + matrix[10] + " " + matrix[11] + " " + matrix[12] + " " + matrix[13] + " " + matrix[14] + "\n      " + matrix[15] + " " + matrix[16] + " " + matrix[17] + " " + matrix[18] + " " + matrix[19]);
    buffer.filter = "url(#" + filterId + ")";
    buffer.drawCanvas(canvas, canvas.padding.left, canvas.padding.top);
    canvas.transform = Matrix.Identity;
    canvas.clear();
    canvas.drawCanvas(buffer, 0, 0, canvas.width, canvas.height);

    if (buffer instanceof Canvas) {
      CanvasPoolSingleton.getInstance().checkIn(buffer);
    }
  };

  ColorAdjustmentFilter.prototype.hasReColor = function hasReColor() {
    return this.grayscl || !!this.duotone || !!this.biLevel || !!this.luminance;
  };

  ColorAdjustmentFilter.prototype.drawGlColorAdjustmentFilter = function drawGlColorAdjustmentFilter(canvas) {
    var buffer = this.getColorAdjustmentSource(canvas);
    var oldGlobalCompositeOperation = canvas.globalCompositeOperation;
    canvas.globalCompositeOperation = "source-in";
    canvas.drawCanvas(buffer, 0, 0);
    canvas.globalCompositeOperation = oldGlobalCompositeOperation;

    if (buffer instanceof Canvas) {
      CanvasPoolSingleton.getInstance().checkIn(buffer);
    }
  };

  ColorAdjustmentFilter.prototype.getColorAdjustmentSource = function getColorAdjustmentSource(canvas) {
    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution);
    buffer.transform = Matrix.Identity;
    buffer.drawCanvas(canvas);
    this.applyGlColorAdjustmentFilter(buffer);
    return buffer;
  };

  ColorAdjustmentFilter.prototype.applyGlColorAdjustmentFilter = function applyGlColorAdjustmentFilter(canvas, obj) {
    var buffer = canvas.getGlBuffer(canvas.width, canvas.height);

    if (!buffer) {
      this.applySvgColorAdjustmentFilter(canvas);
      return;
    }

    glColorMatrixFilterWithGray(buffer, canvas.native, this.colorMatrix, this.biLevel, this.duotone, this.luminance);

    if (obj && obj instanceof SvgGraphics) {
      canvas.save();
      canvas.clip();
      canvas.transform = obj.worldTransform;
      drawPath(canvas, obj.segments);
      canvas.clear();
      canvas.drawCanvas(buffer, -canvas.padding.left, -canvas.padding.top, canvas.width, canvas.height);
      canvas.restore();
    } else {
      canvas.transform = Matrix.Identity;
      canvas.clear();
      canvas.drawCanvas(buffer, -canvas.padding.left, -canvas.padding.top, canvas.width, canvas.height);
    }
  };

  ColorAdjustmentFilter.prototype._updated = function _updated() {
    Filter.prototype._updated.call(this);

    this._colorMatrixDirty = true;
  };

  Object.defineProperties(ColorAdjustmentFilter.prototype, prototypeAccessors);
  return ColorAdjustmentFilter;
}(Filter);
ColorAdjustmentFilter.defaults = {
  temperature: 6500,
  contrast: 1,
  brightness: 1,
  saturate: 1,
  grayscl: false
};
function glColorMatrixFilterWithGray(glBuffer, src, colorMatrix, biLevel, duotone, luminance) {
  var gl = glBuffer.gl;
  var vertexShader = glBuffer.getDefaultVertexShader();
  var fragmentShader = glBuffer.getShader("color-matrix", gl.FRAGMENT_SHADER, "\n    precision mediump float;\n\n    uniform sampler2D u_image;\n    uniform float m[20];\n    uniform float biLevel;\n    uniform int luminance;\n    uniform vec3 color1;\n    uniform vec3 color2;\n    varying vec2 v_texCoord;\n\n    void main() {\n      vec4 c = texture2D(u_image, v_texCoord);\n      gl_FragColor.r = m[0] * c.r + m[1] * c.g + m[2] * c.b + m[3] * c.a + m[4];\n      gl_FragColor.g = m[5] * c.r + m[6] * c.g + m[7] * c.b + m[8] * c.a + m[9];\n      gl_FragColor.b = m[10] * c.r + m[11] * c.g + m[12] * c.b + m[13] * c.a + m[14];\n      gl_FragColor.a = m[15] * c.r + m[16] * c.g + m[17] * c.b + m[18] * c.a + m[19];\n\n      if (bool(biLevel)) {\n        // 经过灰度处理后，rgb三通道相同\n        float gray = gl_FragColor.r;\n        gl_FragColor.r = gray >= float(biLevel) ? 1.0 : 0.0;\n        gl_FragColor.g = gray >= float(biLevel) ? 1.0 : 0.0;\n        gl_FragColor.b = gray >= float(biLevel) ? 1.0 : 0.0;\n      }\n\n      if (bool(color1) || bool(color2)) {\n        // 经过灰度处理后，rgb三通道相同\n        float gray = gl_FragColor.r;\n        gl_FragColor.r = (color1.x * (1.0 - gray)) + (color2.x * gray);\n        gl_FragColor.g = (color1.y * (1.0 - gray)) + (color2.y * gray);\n        gl_FragColor.b = (color1.z * (1.0 - gray)) + (color2.z * gray);\n      }\n\n      if (bool(luminance)) {\n        // 冲蚀效果在最后一步处理中使用白色对图像进行混色\n        gl_FragColor.r = gl_FragColor.r * 0.5 + 0.5;\n        gl_FragColor.g = gl_FragColor.g * 0.5 + 0.5;\n        gl_FragColor.b = gl_FragColor.b * 0.5 + 0.5;\n      }\n    }\n  ");
  glBuffer.useProgram("color-matrix", vertexShader, fragmentShader);
  glBuffer.useTexture(src);
  glBuffer.uniform1fv("m", colorMatrix);

  if (biLevel) {
    glBuffer.uniform1f("biLevel", biLevel / 100);
  } else {
    glBuffer.uniform1f("biLevel", 0);
  }

  if (duotone) {
    var color1 = duotone.color1;
    var color2 = duotone.color2;
    glBuffer.uniform3f("color1", color1.red / 255, color1.green / 255, color1.blue / 255);
    glBuffer.uniform3f("color2", color2.red / 255, color2.green / 255, color2.blue / 255);
  } else {
    glBuffer.uniform3f("color1", 0, 0, 0);
    glBuffer.uniform3f("color2", 0, 0, 0);
  }

  if (luminance) {
    glBuffer.uniform1i("luminance", 1);
  } else {
    glBuffer.uniform1i("luminance", 0);
  }

  glBuffer.drawRect();
}
injectInspector(ColorAdjustmentFilter, [["$", function () {
  return ColorAdjustmentFilter.name;
}], "temperature", "contrast", "brightness", "saturate"]);

var GlowFilter = /*@__PURE__*/function (Filter) {
  function GlowFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "glow";
    this.morphologyFilter = new MorphologyFilter();
    this.blurFilter = new BlurFilter();

    var _a, _b;

    var defaults = getDefaults(this);
    this._color = (_a = options.color) != null ? _a : defaults.color;
    this._size = (_b = options.size) != null ? _b : defaults.size;
    this.morphologyFilter.mode = MorphologyMode.Dilate;
    this.morphologyFilter.ignoreAlpha = true;
    this.blurFilter.maxPadX = Infinity;
    this.blurFilter.maxPadY = Infinity;
  }

  if (Filter) GlowFilter.__proto__ = Filter;
  GlowFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  GlowFilter.prototype.constructor = GlowFilter;
  var prototypeAccessors = {
    color: {
      configurable: true
    },
    size: {
      configurable: true
    }
  };

  prototypeAccessors.color.get = function color() {
    return this._color;
  };

  prototypeAccessors.color.set = function color(value) {
    if (this._color === value) {
      return;
    }

    this._color = value;

    this._updated();
  };

  prototypeAccessors.size.get = function size() {
    return this._size;
  };

  prototypeAccessors.size.set = function size(value) {
    if (this._size === value) {
      return;
    }

    this._size = value;

    this._updated();
  };

  GlowFilter.prototype.apply = function apply(obj, canvas, sx, sy) {
    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution, true);
    buffer.drawCanvas(canvas, -canvas.padding.left, -canvas.padding.top);
    this.updateFilters(canvas.contextScale.sx, canvas.contextScale.sy);
    this.morphologyFilter.forbidWebgl = this.forbidWebgl;
    this.morphologyFilter.apply(obj, buffer, sx, sy);
    this.blurFilter.forbidWebgl = this.forbidWebgl;
    this.blurFilter.apply(obj, buffer, sx, sy);
    buffer.rect(-buffer.padding.left, -buffer.padding.top, buffer.width, buffer.height);
    buffer.nativeFillStyle = this.color.rgba;
    buffer.globalCompositeOperation = "source-in";
    buffer.fill();
    canvas.pad(buffer.padding);
    buffer.padding.copyFrom(canvas.padding);
    canvas.transform = Matrix.Identity;
    canvas.globalCompositeOperation = "destination-over";
    canvas.drawCanvas(buffer);
    canvas.globalCompositeOperation = "source-over";
    CanvasPoolSingleton.getInstance().checkIn(buffer);
  };

  GlowFilter.prototype.updateFilterBounds = function updateFilterBounds(obj, filterBounds) {
    this.updateFilters();
    this.morphologyFilter.updateFilterBounds(obj, filterBounds);
    this.blurFilter.updateFilterBounds(obj, filterBounds);
  };

  GlowFilter.prototype.updateFilters = function updateFilters(contextSx, contextSy) {
    if (contextSx === void 0) contextSx = 1;
    if (contextSy === void 0) contextSy = 1;
    var ref = this;
    var size = ref.size;
    var dilateRadius = size / 2;
    var blurRadius = size * 2 / 3;
    this.morphologyFilter.radiusX = dilateRadius * contextSx;
    this.morphologyFilter.radiusY = dilateRadius * contextSy;
    this.blurFilter.radiusX = blurRadius * contextSx;
    this.blurFilter.radiusY = blurRadius * contextSy;
  };

  Object.defineProperties(GlowFilter.prototype, prototypeAccessors);
  return GlowFilter;
}(Filter);
GlowFilter.defaults = {
  color: Color.Black,
  size: 4
};
injectInspector(GlowFilter, [["$", function () {
  return GlowFilter.name;
}], "color", "size"]);

var Direction = /* @__PURE__ */function (Direction2) {
  Direction2[Direction2["HORIZONTAL"] = 0] = "HORIZONTAL";
  Direction2[Direction2["VERTICAL"] = 1] = "VERTICAL";
  return Direction2;
}(Direction || {});
var ReflectionFilter = /*@__PURE__*/function (Filter) {
  function ReflectionFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "reflection";
    this.blurFilter = new BlurFilter();
    this.filterTransform = new Matrix();
    this.parentRotation = 0;
    this.contextSx = 1;
    this.contextSy = 1;

    var _a, _b, _c, _d, _e, _f, _g, _h;

    var defaults = getDefaults(this);
    this._height = (_a = options.height) != null ? _a : defaults.height;
    this._blur = (_b = options.blur) != null ? _b : defaults.blur;
    this._distance = (_c = options.distance) != null ? _c : defaults.distance;
    this._gradientBeginAlpha = (_d = options.gradientBeginAlpha) != null ? _d : defaults.gradientBeginAlpha;
    this._gradientEndAlpha = (_e = options.gradientEndAlpha) != null ? _e : defaults.gradientEndAlpha;
    this._direction = (_f = options.direction) != null ? _f : defaults.direction;
    this._flip = (_g = options.flip) != null ? _g : defaults.flip;
    this._rotateWithElement = (_h = options.rotateWithElement) != null ? _h : defaults.rotateWithElement;
  }

  if (Filter) ReflectionFilter.__proto__ = Filter;
  ReflectionFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  ReflectionFilter.prototype.constructor = ReflectionFilter;
  var prototypeAccessors = {
    height: {
      configurable: true
    },
    blur: {
      configurable: true
    },
    distance: {
      configurable: true
    },
    gradientBeginAlpha: {
      configurable: true
    },
    gradientEndAlpha: {
      configurable: true
    },
    direction: {
      configurable: true
    },
    flip: {
      configurable: true
    },
    rotateWithElement: {
      configurable: true
    }
  };

  prototypeAccessors.height.get = function height() {
    return this._height;
  };

  prototypeAccessors.height.set = function height(value) {
    if (this._height === value) {
      return;
    }

    this._height = value;

    this._updated();
  };

  prototypeAccessors.blur.get = function blur() {
    return this._blur;
  };

  prototypeAccessors.blur.set = function blur(value) {
    if (this._blur === value) {
      return;
    }

    this._blur = value;

    this._updated();
  };

  prototypeAccessors.distance.get = function distance() {
    return this._distance;
  };

  prototypeAccessors.distance.set = function distance(value) {
    if (this._distance === value) {
      return;
    }

    this._distance = value;

    this._updated();
  };

  prototypeAccessors.gradientBeginAlpha.get = function gradientBeginAlpha() {
    return this._gradientBeginAlpha;
  };

  prototypeAccessors.gradientBeginAlpha.set = function gradientBeginAlpha(value) {
    if (this._gradientBeginAlpha === value) {
      return;
    }

    this._gradientBeginAlpha = value;

    this._updated();
  };

  prototypeAccessors.gradientEndAlpha.get = function gradientEndAlpha() {
    return this._gradientEndAlpha;
  };

  prototypeAccessors.gradientEndAlpha.set = function gradientEndAlpha(value) {
    if (this._gradientEndAlpha === value) {
      return;
    }

    this._gradientEndAlpha = value;

    this._updated();
  };

  prototypeAccessors.direction.get = function direction() {
    return this._direction;
  };

  prototypeAccessors.direction.set = function direction(value) {
    if (this._direction === value) {
      return;
    }

    this._direction = value;

    this._updated();
  };

  prototypeAccessors.flip.get = function flip() {
    return this._flip;
  };

  prototypeAccessors.flip.set = function flip(value) {
    if (this._flip === value) {
      return;
    }

    this._flip = value;

    this._updated();
  };

  prototypeAccessors.rotateWithElement.get = function rotateWithElement() {
    return this._rotateWithElement;
  };

  prototypeAccessors.rotateWithElement.set = function rotateWithElement(value) {
    if (this._rotateWithElement === value) {
      return;
    }

    this._rotateWithElement = value;

    this._updated();
  };

  ReflectionFilter.prototype.apply = function apply(obj, canvas, sx, sy) {
    if (this.height === 0) {
      return;
    }

    this.contextSx = canvas.contextScale.sx;
    this.contextSy = canvas.contextScale.sy;
    var buffer = this.createReflectonBuffer(obj, canvas);
    this.clipBuffer(obj, buffer);
    this.drawReflection(obj, canvas, buffer, sx, sy);
    CanvasPoolSingleton.getInstance().checkIn(buffer);
  };

  ReflectionFilter.prototype.getFilterMatrix = function getFilterMatrix(obj, initialBounds) {
    this.contextSx = 1;
    this.contextSy = 1;
    this.updateFilterTransform(obj, initialBounds);
    return this.filterTransform;
  };

  ReflectionFilter.prototype.updateFilterBounds = function updateFilterBounds(obj, filterBounds, initialBounds) {
    this.contextSx = 1;
    this.contextSy = 1;
    this.updateFilterTransform(obj, initialBounds);
    filterBounds.addBoundsMatrix(this.filterTransform, filterBounds);
  };

  ReflectionFilter.prototype.createReflectonBuffer = function createReflectonBuffer(obj, canvas) {
    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution, true);
    var transform = this.getTransform(obj, canvas.contentWidth, canvas.contentHeight).matrix;
    this.updateBufferPadding(canvas, buffer, transform);
    buffer.save();
    buffer.transform = transform;
    buffer.drawCanvas(canvas, 0, 0);
    buffer.restore();
    return buffer;
  };

  ReflectionFilter.prototype.clipBuffer = function clipBuffer(obj, buffer) {
    buffer.save();
    buffer.nativeFillStyle = this.getGradient(obj, buffer);
    var clipWidth = this.direction === 0
    /* HORIZONTAL */
    ? this.height : 1;
    var clipHeight = this.direction === 1
    /* VERTICAL */
    ? this.height : 1;

    if (this.rotateWithElement) {
      var offsetX = obj.initialBounds.width / 2;
      var offsetY = obj.initialBounds.height / 2;
      var mat = new Matrix().copyFrom(obj.worldTransform);
      mat.tx = obj.worldBounds.width / 2 - (offsetX * mat.a + offsetY * mat.c);
      mat.ty = obj.worldBounds.height / 2 - (offsetX * mat.b + offsetY * mat.d);
      buffer.transform = mat;
    } else {
      buffer.transform = Matrix.Identity;
    }

    var ref = this.getRectArea(buffer);
    var paddingLeft = ref.paddingLeft;
    var paddingTop = ref.paddingTop;
    var contentWidth = ref.contentWidth;
    var contentHeight = ref.contentHeight;
    buffer.rect(this.flip ? contentWidth * (1 - clipWidth) - paddingLeft : -paddingLeft, this.flip ? contentHeight * (1 - clipHeight) - paddingTop : -paddingTop, contentWidth * clipWidth + Math.abs(paddingLeft), contentHeight * clipHeight + Math.abs(paddingTop));
    buffer.globalCompositeOperation = "destination-in";
    buffer.fill();
    buffer.restore();
  };

  ReflectionFilter.prototype.drawReflection = function drawReflection(obj, canvas, buffer, sx, sy) {
    var blurSize = this.blur;
    var ref = this.getTranslate(obj, buffer, sx, sy);
    var translateX = ref.translateX;
    var translateY = ref.translateY;
    var ref$1 = this.getPadding(obj, buffer, sx, sy);
    var paddingX = ref$1.paddingX;
    var paddingY = ref$1.paddingY;
    canvas.save();
    canvas.pad(_padding$1.set((translateY < 0 ? paddingY : 0) + blurSize, (translateX > 0 ? paddingX : 0) + blurSize, (translateY > 0 ? paddingY : 0) + blurSize, (translateX < 0 ? paddingX : 0) + blurSize).overlay(buffer.padding));
    canvas.transform = new Matrix().translate(translateX, translateY);
    canvas.globalAlpha = 1;
    canvas.globalCompositeOperation = "destination-over";
    canvas.drawCanvas(this.getBlurSource(obj, buffer, sx, sy), 0, 0);
    canvas.restore();
    CanvasPoolSingleton.getInstance().checkIn(buffer);
  };

  ReflectionFilter.prototype.updateBufferPadding = function updateBufferPadding(canvas, buffer, transform) {
    if (this.rotateWithElement) {
      var bounds = _bounds$1.clear().addBounds(canvas.bounds).transform(transform);

      var pad = buffer.bounds.paddingTo(bounds, _padding$1);
      buffer.pad(pad);
    } else {
      buffer.padding.add(this.getBufferPadding(canvas));
    }

    _padding$1.clear();
  };

  ReflectionFilter.prototype.getBufferPadding = function getBufferPadding(canvas) {
    var ref = canvas.padding;
    var top = ref.top;
    var left = ref.left;
    var right = ref.right;
    var bottom = ref.bottom;

    if (this.direction === 0
    /* HORIZONTAL */
    ) {
      _padding$1.set(top, left, bottom, right);
    } else {
      _padding$1.set(bottom, right, top, left);
    }

    return _padding$1;
  };

  ReflectionFilter.prototype.getRectArea = function getRectArea(buffer) {
    var invertedMatrix = _matrix.copyFrom(buffer.transform).invert();

    var bounds = _bounds$1.clear().addBounds(buffer.bounds).transform(invertedMatrix);

    var paddingLeft = this.rotateWithElement ? 0 - bounds.minX : buffer.padding.left;
    var paddingTop = this.rotateWithElement ? 0 - bounds.minY : buffer.padding.top;
    var contentWidth = this.rotateWithElement ? bounds.width : buffer.width;
    var contentHeight = this.rotateWithElement ? bounds.height : buffer.height;
    return {
      paddingLeft: paddingLeft,
      paddingTop: paddingTop,
      contentWidth: contentWidth,
      contentHeight: contentHeight
    };
  };

  ReflectionFilter.prototype.getGradient = function getGradient(obj, buffer) {
    var ref = this.getOffsetSize(obj, buffer);
    var offsetWidth = ref.offsetWidth;
    var offsetHeight = ref.offsetHeight;
    var gradient = null;

    if (this.flip) {
      gradient = buffer.createLinearGradient(offsetWidth * (1 - this.height), offsetHeight * (1 - this.height), offsetWidth, offsetHeight);
    } else {
      gradient = buffer.createLinearGradient(0, 0, offsetWidth * this.height, offsetHeight * this.height);
    }

    gradient.addColorStop(this.flip ? 1 : 0, "rgba(0, 0, 0, " + this.gradientBeginAlpha + ")");
    gradient.addColorStop(this.flip ? 0 : 1, "rgba(0, 0, 0, " + this.gradientEndAlpha + ")");
    return gradient;
  };

  ReflectionFilter.prototype.getOffsetSize = function getOffsetSize(obj, buffer) {
    var offsetWidth = 0;
    var offsetHeight = 0;

    if (this.direction === 0
    /* HORIZONTAL */
    ) {
      offsetWidth = this.rotateWithElement ? obj.initialBounds.width : buffer.contentWidth;
    } else {
      offsetHeight = this.rotateWithElement ? obj.initialBounds.height : buffer.contentHeight;
    }

    return {
      offsetWidth: offsetWidth,
      offsetHeight: offsetHeight
    };
  };

  ReflectionFilter.prototype.getTranslate = function getTranslate(obj, buffer, sx, sy) {
    var ref = this.getOffsetSize(obj, buffer);
    var offsetWidth = ref.offsetWidth;
    var offsetHeight = ref.offsetHeight;
    var distanceX = (this.direction === 0
    /* HORIZONTAL */
    ? this.distance * this.contextSx : 0) * (this.rotateWithElement ? 1 / obj.scaleX : sx);
    var distanceY = (this.direction === 1
    /* VERTICAL */
    ? this.distance * this.contextSy : 0) * (this.rotateWithElement ? 1 / obj.scaleY : sy);
    var translateX = 0;
    var translateY = 0;

    if (this.rotateWithElement) {
      var mat = obj.worldTransform;
      translateX += (offsetWidth + distanceX) * mat.a + (offsetHeight + distanceY) * mat.c;
      translateY += (offsetWidth + distanceX) * mat.b + (offsetHeight + distanceY) * mat.d;
    } else {
      translateX += offsetWidth + distanceX;
      translateY += offsetHeight + distanceY;
    }

    translateX *= this.flip ? -1 : 1;
    translateY *= this.flip ? -1 : 1;
    return {
      translateX: translateX,
      translateY: translateY
    };
  };

  ReflectionFilter.prototype.getPadding = function getPadding(obj, buffer, sx, sy) {
    var ref = this.getOffsetSize(obj, buffer);
    var offsetWidth = ref.offsetWidth;
    var offsetHeight = ref.offsetHeight;
    var distanceX = (this.direction === 0
    /* HORIZONTAL */
    ? this.distance * this.contextSx : 0) * (this.rotateWithElement ? 1 / obj.scaleX : sx);
    var distanceY = (this.direction === 1
    /* VERTICAL */
    ? this.distance * this.contextSy : 0) * (this.rotateWithElement ? 1 / obj.scaleY : sy);
    var paddingX = 0;
    var paddingY = 0;

    if (this.rotateWithElement) {
      var mat = obj.worldTransform;
      paddingX += (offsetWidth * this.height + distanceX) * mat.a + (offsetHeight * this.height + distanceY) * mat.c;
      paddingY += (offsetWidth * this.height + distanceX) * mat.b + (offsetHeight * this.height + distanceY) * mat.d;
    } else {
      paddingX += offsetWidth * this.height + distanceX;
      paddingY += offsetHeight * this.height + distanceY;
    }

    paddingX = Math.abs(paddingX);
    paddingY = Math.abs(paddingY);
    return {
      paddingX: paddingX,
      paddingY: paddingY
    };
  };

  ReflectionFilter.prototype.getTransform = function getTransform(obj, width, height) {
    var transform = new Transform();

    if (this.direction === 0
    /* HORIZONTAL */
    ) {
      transform.scaleX = -1;
    } else {
      transform.scaleY = -1;
    }

    transform.pivotX = 0.5 * width;
    transform.pivotY = 0.5 * height;
    transform.translateX = transform.pivotX;
    transform.translateY = transform.pivotY;

    if (this.rotateWithElement) {
      var worldRotation = obj.rotation;
      var parentObj = obj.parent;

      while (parentObj) {
        worldRotation += parentObj.rotation;
        parentObj = parentObj.parent;
      }

      transform.rotation = worldRotation * 2;
    }

    return transform;
  };

  ReflectionFilter.prototype.getBlurSource = function getBlurSource(obj, src, sx, sy) {
    if (this.blur === 0) {
      return src;
    }

    var buffer = CanvasPoolSingleton.getInstance().checkOut(src.constructor);
    buffer.resetBufferInfo(src, src.width, src.height, src.resolution, true);
    buffer.padding.copyFrom(src.padding);
    buffer.transform = Matrix.Identity;
    buffer.drawCanvas(src);
    this.updateFilters();
    this.blurFilter.forbidWebgl = this.forbidWebgl;
    this.blurFilter.apply(obj, buffer, sx, sy);
    return buffer;
  };

  ReflectionFilter.prototype.updateFilters = function updateFilters() {
    var ref = this;
    var blur = ref.blur;
    this.blurFilter.radiusX = blur;
    this.blurFilter.radiusY = blur;
  };

  ReflectionFilter.prototype.updateFilterTransform = function updateFilterTransform(obj, initialBounds) {
    this.updateParentRotation(obj);
    var ref = this.calculatePivot(obj, initialBounds);
    var pivotX = ref.pivotX;
    var pivotY = ref.pivotY;
    var ref$1 = this.calculateDistance();
    var distanceX = ref$1.distanceX;
    var distanceY = ref$1.distanceY;
    var translateX = pivotX + distanceX;
    var translateY = pivotY + distanceY;
    var scaleX = this.direction === 0
    /* HORIZONTAL */
    ? -1 : 1;
    var scaleY = this.direction === 0
    /* HORIZONTAL */
    ? 1 : -1;
    this.filterTransform.set(1, 0, 0, 1, -pivotX, -pivotY).rotate(this.rotateWithElement ? 0 : this.parentRotation * 2).scale(scaleX, scaleY).translate(translateX, translateY);
  };

  ReflectionFilter.prototype.calculateDistance = function calculateDistance() {
    var distanceX = 0;
    var distanceY = 0;
    var flag = this.flip ? -1 : 1;

    if (this.rotateWithElement) {
      if (this.direction === 0
      /* HORIZONTAL */
      ) {
        distanceX = this.distance * flag;
      } else {
        distanceY = this.distance * flag;
      }

      return {
        distanceX: distanceX,
        distanceY: distanceY
      };
    }

    distanceX = this.distance * Math.sin(this.parentRotation);
    distanceY = this.distance * Math.cos(this.parentRotation);
    return {
      distanceX: distanceX,
      distanceY: distanceY
    };
  };

  ReflectionFilter.prototype.calculatePivot = function calculatePivot(obj, initialBounds) {
    var pivotX = 0;
    var pivotY = 0;

    if (this.rotateWithElement) {
      if (!this.flip) {
        pivotX = initialBounds.width + initialBounds.x;
        pivotY = initialBounds.height + initialBounds.y;
      }

      return {
        pivotX: pivotX,
        pivotY: pivotY
      };
    }

    if (this.shouldOriginToLeftTop()) {
      pivotX = initialBounds.x;
      pivotY = initialBounds.y;
    } else if (this.shouldOriginToRightTop()) {
      pivotX = initialBounds.width + initialBounds.x;
      pivotY = initialBounds.y;
    } else if (this.shouldOriginToLeftBottom()) {
      pivotX = initialBounds.x;
      pivotY = initialBounds.height + initialBounds.y;
    } else {
      pivotX = initialBounds.width + initialBounds.x;
      pivotY = initialBounds.height + initialBounds.y;
    }

    return {
      pivotX: pivotX,
      pivotY: pivotY
    };
  };

  ReflectionFilter.prototype.shouldOriginToLeftTop = function shouldOriginToLeftTop() {
    return this.direction === 0
    /* HORIZONTAL */
    && this.parentRotation >= 90 * DEG_TO_RAD && this.parentRotation < 180 * DEG_TO_RAD || this.direction === 1
    /* VERTICAL */
    && this.parentRotation >= 180 * DEG_TO_RAD && this.parentRotation < 270 * DEG_TO_RAD;
  };

  ReflectionFilter.prototype.shouldOriginToRightTop = function shouldOriginToRightTop() {
    return this.direction === 0
    /* HORIZONTAL */
    && this.parentRotation >= 0 && this.parentRotation < 90 * DEG_TO_RAD || this.direction === 1
    /* VERTICAL */
    && this.parentRotation >= 90 * DEG_TO_RAD && this.parentRotation < 180 * DEG_TO_RAD;
  };

  ReflectionFilter.prototype.shouldOriginToLeftBottom = function shouldOriginToLeftBottom() {
    return this.direction === 0
    /* HORIZONTAL */
    && this.parentRotation >= 180 * DEG_TO_RAD && this.parentRotation < 270 * DEG_TO_RAD || this.direction === 1
    /* VERTICAL */
    && this.parentRotation >= 270 * DEG_TO_RAD && this.parentRotation < 360 * DEG_TO_RAD;
  };

  ReflectionFilter.prototype.updateParentRotation = function updateParentRotation(obj) {
    this.parentRotation = obj.rotation;
    var parentObj = obj.parent;

    while (parentObj) {
      this.parentRotation += parentObj.rotation;
      parentObj = parentObj.parent;
    }
  };

  Object.defineProperties(ReflectionFilter.prototype, prototypeAccessors);
  return ReflectionFilter;
}(Filter);
ReflectionFilter.defaults = {
  height: 1,
  blur: 4,
  distance: 0,
  gradientBeginAlpha: 1,
  gradientEndAlpha: 0,
  direction: 1
  /* VERTICAL */
  ,
  flip: false,
  rotateWithElement: false
};

var _padding$1 = /*#__PURE__*/new Padding();

var _bounds$1 = /*#__PURE__*/new Bounds();

var _matrix = /*#__PURE__*/new Matrix();

injectInspector(ReflectionFilter, [["$", function () {
  return ReflectionFilter.name;
}], "height", "blur", "distance", "alpha"]);

var ShadowFilter = /*@__PURE__*/function (Filter) {
  function ShadowFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "shadow";
    this.transform = new Matrix();
    this.blurFilter = new BlurFilter();
    this.filterTransform = new Matrix();
    this.parentRotation = 0;
    this.contextSx = 1;
    this.contextSy = 1;

    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;

    var defaults = getDefaults(this);
    this._inner = (_a = options.inner) != null ? _a : defaults.inner;
    this._color = (_b = options.color) != null ? _b : defaults.color;
    this._blur = (_c = options.blur) != null ? _c : defaults.blur;
    this._distance = (_d = options.distance) != null ? _d : defaults.distance;
    this._angle = (_e = options.angle) != null ? _e : defaults.angle;
    this._scaleX = (_f = options.scaleX) != null ? _f : defaults.scaleX;
    this._scaleY = (_g = options.scaleY) != null ? _g : defaults.scaleY;
    this._skewAngleX = (_h = options.skewAngleX) != null ? _h : defaults.skewAngleX;
    this._skewAngleY = (_i = options.skewAngleY) != null ? _i : defaults.skewAngleY;
    this._originX = (_j = options.originX) != null ? _j : defaults.originX;
    this._originY = (_k = options.originY) != null ? _k : defaults.originY;
  }

  if (Filter) ShadowFilter.__proto__ = Filter;
  ShadowFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  ShadowFilter.prototype.constructor = ShadowFilter;
  var prototypeAccessors = {
    inner: {
      configurable: true
    },
    color: {
      configurable: true
    },
    blur: {
      configurable: true
    },
    distance: {
      configurable: true
    },
    angle: {
      configurable: true
    },
    scaleX: {
      configurable: true
    },
    scaleY: {
      configurable: true
    },
    skewAngleX: {
      configurable: true
    },
    skewAngleY: {
      configurable: true
    },
    originX: {
      configurable: true
    },
    originY: {
      configurable: true
    },
    hasNoEffect: {
      configurable: true
    }
  };

  prototypeAccessors.inner.get = function inner() {
    return this._inner;
  };

  prototypeAccessors.inner.set = function inner(value) {
    if (this._inner === value) {
      return;
    }

    this._inner = value;

    this._updated();
  };

  prototypeAccessors.color.get = function color() {
    return this._color;
  };

  prototypeAccessors.color.set = function color(value) {
    if (this._color === value) {
      return;
    }

    this._color = value;

    this._updated();
  };

  prototypeAccessors.blur.get = function blur() {
    return this._blur;
  };

  prototypeAccessors.blur.set = function blur(value) {
    if (this._blur === value) {
      return;
    }

    this._blur = value;

    this._updated();
  };

  prototypeAccessors.distance.get = function distance() {
    return this._distance;
  };

  prototypeAccessors.distance.set = function distance(value) {
    if (this._distance === value) {
      return;
    }

    this._distance = value;

    this._updated();
  };

  prototypeAccessors.angle.get = function angle() {
    return this._angle;
  };

  prototypeAccessors.angle.set = function angle(value) {
    if (this._angle === value) {
      return;
    }

    this._angle = value;

    this._updated();
  };

  prototypeAccessors.scaleX.get = function scaleX() {
    return this._scaleX;
  };

  prototypeAccessors.scaleX.set = function scaleX(value) {
    if (this._scaleX === value) {
      return;
    }

    this._scaleX = value;

    this._updated();
  };

  prototypeAccessors.scaleY.get = function scaleY() {
    return this._scaleY;
  };

  prototypeAccessors.scaleY.set = function scaleY(value) {
    if (this._scaleY === value) {
      return;
    }

    this._scaleY = value;

    this._updated();
  };

  prototypeAccessors.skewAngleX.get = function skewAngleX() {
    return this._skewAngleX;
  };

  prototypeAccessors.skewAngleX.set = function skewAngleX(value) {
    if (this._skewAngleX === value) {
      return;
    }

    this._skewAngleX = value;

    this._updated();
  };

  prototypeAccessors.skewAngleY.get = function skewAngleY() {
    return this._skewAngleY;
  };

  prototypeAccessors.skewAngleY.set = function skewAngleY(value) {
    if (this._skewAngleY === value) {
      return;
    }

    this._skewAngleY = value;

    this._updated();
  };

  prototypeAccessors.originX.get = function originX() {
    return this._originX;
  };

  prototypeAccessors.originX.set = function originX(value) {
    if (this._originX === value) {
      return;
    }

    this._originX = value;

    this._updated();
  };

  prototypeAccessors.originY.get = function originY() {
    return this._originY;
  };

  prototypeAccessors.originY.set = function originY(value) {
    if (this._originY === value) {
      return;
    }

    this._originY = value;

    this._updated();
  };

  prototypeAccessors.hasNoEffect.get = function hasNoEffect() {
    return this.scaleX === 1 && this.scaleY === 1 && this.blur === 0 && this.distance === 0 && this.skewAngleX === 0 && this.skewAngleY === 0;
  };

  ShadowFilter.prototype.apply = function apply(obj, canvas, sx, sy) {
    if (this.hasNoEffect) {
      return;
    }

    this.contextSx = canvas.contextScale.sx;
    this.contextSy = canvas.contextScale.sy;
    this.updateParentRotation(obj);
    this.updateTransform(obj, canvas.contentWidth, canvas.contentHeight);
    var buffer = this.createBuffer(canvas);
    var shadowBounds = this.getShadowBounds(buffer.bounds);

    if (this.inner) {
      var padding = buffer.bounds.paddingTo(shadowBounds.addBounds(canvas.bounds), _padding).flip();
      buffer.pad(padding.overlay(Padding.Zero));
      this.drawShadow(obj, canvas, buffer, sx, sy);
    } else {
      var padding$1 = canvas.bounds.paddingTo(shadowBounds, _padding);
      this.drawShadow(obj, canvas, buffer, sx, sy);
      canvas.pad(padding$1.overlay(Padding.Zero));
    }

    canvas.save();
    canvas.globalCompositeOperation = this.inner ? "source-atop" : "destination-over";
    canvas.transform = this.transform;
    canvas.drawCanvas(buffer);
    canvas.restore();
    CanvasPoolSingleton.getInstance().checkIn(buffer);
  };

  ShadowFilter.prototype.getFilterMatrix = function getFilterMatrix(obj) {
    this.contextSx = 1;
    this.contextSy = 1;
    this.updateFilterTransform(obj);
    return this.filterTransform;
  };

  ShadowFilter.prototype.updateFilterBounds = function updateFilterBounds(obj, filterBounds) {
    this.contextSx = 1;
    this.contextSy = 1;
    this.updateFilterTransform(obj);
    filterBounds.addBoundsMatrix(this.filterTransform, filterBounds);
    this.updateFilters();
    this.blurFilter.updateFilterBounds(obj, filterBounds);
  };

  ShadowFilter.prototype.createBuffer = function createBuffer(canvas) {
    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution, true);
    buffer.padding.add(canvas.padding);
    return buffer;
  };

  ShadowFilter.prototype.drawShadow = function drawShadow(obj, canvas, buffer, sx, sy) {
    buffer.save();
    buffer.transform = this.inner ? Matrix.Identity : this.getBufferTransform(buffer);

    if (this.inner) {
      buffer.rect(-buffer.padding.left, -buffer.padding.top, buffer.width, buffer.height);
    } else {
      buffer.rect(0, 0, buffer.width, buffer.height);
    }

    buffer.nativeFillStyle = this.color.rgba;
    buffer.fill();
    buffer.globalCompositeOperation = this.inner ? "destination-out" : "destination-in";

    if (this.inner) {
      buffer.drawCanvas(canvas);
    } else {
      buffer.drawCanvas(canvas, buffer.padding.left, buffer.padding.top);
    }

    buffer.restore();
    this.updateFilters();
    this.blurFilter.forbidWebgl = this.forbidWebgl;
    this.blurFilter.apply(obj, buffer, sx, sy);
  };

  ShadowFilter.prototype.updateFilters = function updateFilters() {
    var ref = this;
    var blur = ref.blur;
    var inner = ref.inner;
    this.blurFilter.radiusX = blur * this.contextSx;
    this.blurFilter.radiusY = blur * this.contextSy;

    if (inner) {
      this.blurFilter.maxPadX = 0;
      this.blurFilter.maxPadY = 0;
    } else {
      this.blurFilter.maxPadX = Infinity;
      this.blurFilter.maxPadY = Infinity;
    }
  };

  ShadowFilter.prototype.updateParentRotation = function updateParentRotation(obj) {
    if (this.inner) {
      return;
    }

    this.parentRotation = 0;
    var parentObj = obj.parent;

    while (parentObj) {
      this.parentRotation += parentObj.rotation;
      parentObj = parentObj.parent;
    }
  };

  ShadowFilter.prototype.getBufferTransform = function getBufferTransform(buffer) {
    var transform = new Transform();
    transform.pivotX = buffer.width / 2;
    transform.pivotY = buffer.height / 2;
    transform.translateX = buffer.width / 2 - buffer.padding.left;
    transform.translateY = buffer.height / 2 - buffer.padding.top;
    transform.rotation = -this.parentRotation;
    return transform.matrix;
  };

  ShadowFilter.prototype.updateTransform = function updateTransform(obj, width, height) {
    var ref = this.getDistance();
    var xDistance = ref.xDistance;
    var yDistance = ref.yDistance;
    var ref$1 = this.getOffset(obj);
    var xOffset = ref$1.xOffset;
    var yOffset = ref$1.yOffset;
    var mat = obj.worldTransform;
    var pivotX = 0.5 * width;
    var pivotY = 0.5 * height;
    var translateX = pivotX + (xOffset * mat.a + yOffset * mat.c) + (xDistance * mat.a + yDistance * mat.c) / obj.scaleX;
    var translateY = pivotY + (xOffset * mat.b + yOffset * mat.d) + (xDistance * mat.b + yDistance * mat.d) / obj.scaleY;

    if (this.inner) {
      this.transform.set(1, 0, 0, 1, translateX - pivotX, translateY - pivotY);
      return;
    }

    this.updateSkew();
    var rotateMat = new Matrix().rotate(obj.rotation);
    var scaleX = this.scaleX * Math.abs(rotateMat.a) + this.scaleY * Math.abs(rotateMat.c);
    var scaleY = this.scaleX * Math.abs(rotateMat.b) + this.scaleY * Math.abs(rotateMat.d);
    this.transform.set(1, 0, 0, 1, -pivotX, -pivotY).prepend(_skew).scale(scaleX, scaleY).rotate(this.parentRotation).translate(translateX, translateY);
  };

  ShadowFilter.prototype.updateFilterTransform = function updateFilterTransform(obj) {
    var ref = this.getDistance();
    var xDistance = ref.xDistance;
    var yDistance = ref.yDistance;
    var ref$1 = this.getFilterOffset(obj);
    var xOffset = ref$1.xOffset;
    var yOffset = ref$1.yOffset;
    var translateX = xOffset + xDistance;
    var translateY = yOffset + yDistance;

    if (this.inner) {
      this.filterTransform.set(1, 0, 0, 1, translateX, translateY);
      return;
    }

    this.updateSkew();
    this.filterTransform.set(1, 0, 0, 1, 0, 0).prepend(_skew).scale(this.scaleX, this.scaleY).translate(translateX, translateY);
  };

  ShadowFilter.prototype.getShadowBounds = function getShadowBounds(original) {
    return _bounds.clear().addBounds(original).pad(_padding.setEvenly(this.blur * 2)).transform(this.transform);
  };

  ShadowFilter.prototype.getOffset = function getOffset(obj) {
    var width = this.contextSx * obj.width;
    var height = this.contextSy * obj.height;
    var skewX = Math.tan(this.skewAngleX * DEG_TO_RAD * (this.contextSx / this.contextSy));
    var skewY = Math.tan(this.skewAngleY * DEG_TO_RAD * (this.contextSy / this.contextSx));
    var xOffset = width * (0.5 - this.originX) * (this.scaleX - 1) + height * skewX * (0.5 - this.originY) * this.scaleX;
    var yOffset = height * (0.5 - this.originY) * (this.scaleY - 1) + width * skewY * (0.5 - this.originX) * this.scaleY;
    return {
      xOffset: xOffset,
      yOffset: yOffset
    };
  };

  ShadowFilter.prototype.getFilterOffset = function getFilterOffset(obj) {
    var width = this.contextSx * obj.width;
    var height = this.contextSy * obj.height;
    var skewX = Math.tan(this.skewAngleX * DEG_TO_RAD * (this.contextSx / this.contextSy));
    var skewY = Math.tan(this.skewAngleY * DEG_TO_RAD * (this.contextSy / this.contextSx));
    var xOffset = width * -this.originX * (this.scaleX - 1) + height * skewX * -this.originY * this.scaleX;
    var yOffset = height * -this.originY * (this.scaleY - 1) + width * skewY * -this.originX * this.scaleY;
    return {
      xOffset: xOffset,
      yOffset: yOffset
    };
  };

  ShadowFilter.prototype.getDistance = function getDistance() {
    var angle = this.angle - (this.inner ? 180 : 0);
    var xDistance = this.distance * Math.cos(angle * DEG_TO_RAD) * this.contextSx;
    var yDistance = this.distance * Math.sin(angle * DEG_TO_RAD) * this.contextSy;
    return {
      xDistance: xDistance,
      yDistance: yDistance
    };
  };

  ShadowFilter.prototype.updateSkew = function updateSkew() {
    _skew.b = Math.tan(this.skewAngleY * DEG_TO_RAD * (this.contextSy / this.contextSx));
    _skew.c = Math.tan(this.skewAngleX * DEG_TO_RAD * (this.contextSx / this.contextSy));
  };

  Object.defineProperties(ShadowFilter.prototype, prototypeAccessors);
  return ShadowFilter;
}(Filter);
ShadowFilter.defaults = {
  inner: false,
  color: Color.Black,
  blur: 4,
  distance: 4,
  angle: 45,
  scaleX: 1,
  scaleY: 1,
  skewAngleX: 0,
  skewAngleY: 0,
  originX: 0.5,
  originY: 0.5
};

var _bounds = /*#__PURE__*/new Bounds();

var _padding = /*#__PURE__*/new Padding();

var _skew = /*#__PURE__*/new Matrix();

injectInspector(ShadowFilter, [["$", function () {
  return ShadowFilter.name;
}], "inner", "color", "blur", "distance", "angle", "scaleX", "scaleY", "skewAngleX", "skewAngleY", "originX", "originY"]);

var SharpenFilter = /*@__PURE__*/function (Filter) {
  function SharpenFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "sharpen";
    this.convolutionFilter = new Convolution3x3Filter();

    var _a;

    var defaults = getDefaults(this);
    this._size = (_a = options.size) != null ? _a : defaults.size;
  }

  if (Filter) SharpenFilter.__proto__ = Filter;
  SharpenFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  SharpenFilter.prototype.constructor = SharpenFilter;
  var prototypeAccessors = {
    size: {
      configurable: true
    }
  };

  prototypeAccessors.size.get = function size() {
    return this._size;
  };

  prototypeAccessors.size.set = function size(value) {
    if (this._size === value) {
      return;
    }

    this._size = value;

    this._updated();
  };

  SharpenFilter.prototype.apply = function apply(obj, canvas) {
    if (this.size === 0) {
      return;
    }

    this.updateFilters();
    this.convolutionFilter.forbidWebgl = this.forbidWebgl;
    this.convolutionFilter.apply(obj, canvas);
  };

  SharpenFilter.prototype.updateFilters = function updateFilters() {
    var ref = this;
    var size = ref.size;
    var center = size * 16 + 1;
    var side = -4 * size;
    this.convolutionFilter.kernel = [0, side, 0, side, center, side, 0, side, 0];
  };

  Object.defineProperties(SharpenFilter.prototype, prototypeAccessors);
  return SharpenFilter;
}(Filter);
SharpenFilter.defaults = {
  size: 4
};
injectInspector(SharpenFilter, [["$", function () {
  return SharpenFilter.name;
}], "size"]);

var SoftEdgeFilter = /*@__PURE__*/function (Filter) {
  function SoftEdgeFilter(options) {
    if (options === void 0) options = {};
    Filter.call(this);
    this.type = "soft-edge";
    this.morphologyFilter = new MorphologyFilter();
    this.blurFilter = new BlurFilter();

    var _a, _b;

    var defaults = getDefaults(this);
    this._size = (_a = options.size) != null ? _a : defaults.size;
    this._isPicture = (_b = options.isPicture) != null ? _b : defaults.isPicture;
    this.morphologyFilter.mode = MorphologyMode.Erode;
    this.morphologyFilter.ignoreAlpha = true;
    this.blurFilter.maxPadX = Infinity;
    this.blurFilter.maxPadY = Infinity;
  }

  if (Filter) SoftEdgeFilter.__proto__ = Filter;
  SoftEdgeFilter.prototype = /*#__PURE__*/Object.create(Filter && Filter.prototype);
  SoftEdgeFilter.prototype.constructor = SoftEdgeFilter;
  var prototypeAccessors = {
    size: {
      configurable: true
    },
    isPicture: {
      configurable: true
    }
  };

  prototypeAccessors.size.get = function size() {
    return this._size;
  };

  prototypeAccessors.size.set = function size(value) {
    if (this._size === value) {
      return;
    }

    this._size = value;

    this._updated();
  };

  prototypeAccessors.isPicture.get = function isPicture() {
    return this._isPicture;
  };

  prototypeAccessors.isPicture.set = function isPicture(value) {
    if (this._isPicture === value) {
      return;
    }

    this._isPicture = value;

    this._updated();
  };

  SoftEdgeFilter.prototype.apply = function apply(obj, canvas, sx, sy) {
    if (this.size === 0) {
      return;
    }

    var buffer = CanvasPoolSingleton.getInstance().checkOut(canvas.constructor);
    buffer.resetBufferInfo(canvas, canvas.width, canvas.height, canvas.resolution, true);
    buffer.padding.copyFrom(canvas.padding);
    buffer.transform = Matrix.Identity;
    buffer.drawCanvas(canvas);
    this.updateFilters(canvas.contextScale.sx, canvas.contextScale.sy);
    this.morphologyFilter.forbidWebgl = this.forbidWebgl;
    this.morphologyFilter.apply(obj, buffer, sx, sy);
    this.blurFilter.forbidWebgl = this.forbidWebgl;
    this.blurFilter.apply(obj, buffer, sx, sy);
    canvas.transform = Matrix.Identity;
    canvas.globalCompositeOperation = "destination-in";
    canvas.drawCanvas(buffer);
    canvas.globalCompositeOperation = "source-over";
    CanvasPoolSingleton.getInstance().checkIn(buffer);
  };

  SoftEdgeFilter.prototype.updateFilters = function updateFilters(contextSx, contextSy) {
    var ref = this;
    var size = ref.size;
    this.morphologyFilter.radiusX = size * contextSx;
    this.morphologyFilter.radiusY = size * contextSy;
    this.morphologyFilter.isPicture = this.isPicture;
    this.blurFilter.radiusX = size * contextSx;
    this.blurFilter.radiusY = size * contextSy;
  };

  Object.defineProperties(SoftEdgeFilter.prototype, prototypeAccessors);
  return SoftEdgeFilter;
}(Filter);
SoftEdgeFilter.defaults = {
  size: 4,
  isPicture: false
};
injectInspector(SoftEdgeFilter, [["$", function () {
  return SoftEdgeFilter.name;
}], "size"]);

export { ColorAdjustmentFilter, Direction, GlowFilter, ReflectionFilter, ShadowFilter, SharpenFilter, SoftEdgeFilter, glColorMatrixFilterWithGray };
//# sourceMappingURL=alloy-renderer-tdoc.esm.js.map
